import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ExtractionProvider } from "@/context/ExtractionContext";
import ExtractionIndicator from "@/components/ExtractionIndicator";
import DropGuard from "@/components/DropGuard";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import Pratiche from "@/pages/Pratiche";
import PraticaDetail from "@/pages/PraticaDetail";
import Clienti from "@/pages/Clienti";
import ClienteDetail from "@/pages/ClienteDetail";
import TipiPratica from "@/pages/TipiPratica";
import RequirePerm from "@/components/RequirePerm";
import Fatture from "@/pages/Fatture";
import Contabilita from "@/pages/Contabilita";
import Impostazioni from "@/pages/Impostazioni";
import AuthGoogle from "@/pages/AuthGoogle";

const Protected = ({ children }) => {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
};

function App() {
  return (
    <AuthProvider>
      <ExtractionProvider>
      <DropGuard />
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/google" element={<Protected><AuthGoogle /></Protected>} />
          <Route
            path="/"
            element={
              <Protected>
                <Layout />
              </Protected>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="pratiche" element={<Pratiche />} />
            <Route path="pratiche/:id" element={<PraticaDetail />} />
            <Route path="clienti" element={<Clienti />} />
            <Route path="clienti/:id" element={<ClienteDetail />} />
            <Route path="tipi-pratica" element={<TipiPratica />} />
            <Route path="fatture" element={<RequirePerm perm="vedi_dati_economici"><Fatture /></RequirePerm>} />
            <Route path="contabilita" element={<RequirePerm perm="vedi_dati_economici"><Contabilita /></RequirePerm>} />
            <Route path="impostazioni" element={<Impostazioni />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <ExtractionIndicator />
      </ExtractionProvider>
    </AuthProvider>
  );
}

export default App;
